module.exports = __webpack_public_path__ + "static/media/environment.f3210b88.jpg";